/** Auto-generated / agent list names → List N (storage unchanged). */
const ORCH_LIKE =
  /^(ORCH|Agent[A-Z]?|E2E|TEST|BOS|UI|LiveOk|WebFix|Web|Fix|Orch)\d+/i;
/** QA / E2E automation prefixes (hyphenated or glued), e.g. ListQA-*, QA-E2E-* */
const QA_AUTO =
  /^(ListQA|QA[-_]?(?:E2E|TEST|ORCH|UI|Agent)|(?:E2E|ORCH|TEST)[-_])/i;
/** letters/digits ending in 6+ digits, or opaque id-like tokens */
const AUTO_ID = /^(?=.*\d)[A-Za-z]{0,12}\d{6,}$|^[A-Za-z0-9]{10,}$/;

function looksLikeGibberish(raw: string): boolean {
  if (/^LIST\d+$/i.test(raw)) return true;
  if (!/^[A-Za-z0-9]+$/.test(raw)) return false;
  if (!/\d/.test(raw) || !/[A-Za-z]/.test(raw)) return false;
  if (raw.length >= 8) return true;
  // short letter/digit soup (g23g2, r2r2)
  return raw.length >= 4 && (raw.match(/\d+/g) || []).length >= 2;
}

export function isOrchLikeFolderName(name: string | null | undefined): boolean {
  const raw = (name || '').trim();
  if (!raw) return true;
  if (ORCH_LIKE.test(raw)) return true;
  if (QA_AUTO.test(raw)) return true;
  if (AUTO_ID.test(raw)) return true;
  if (looksLikeGibberish(raw)) return true;
  return false;
}

/** @param index 0-based position in the current sorted list for unique labels */
export function displayFolderName(name: string | null | undefined, index = 0): string {
  if (isOrchLikeFolderName(name)) return `List ${index + 1}`;
  return (name || '').trim();
}
